module.exports = __webpack_public_path__ + "img/ИФ-1(А)-038-m.1000ce6f.png";